var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _circle, _path10, _path11, _rect, _rect2, _rect3, _g2, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderProject = function SvgOrderProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 141,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D7F1F9",
    d: "M172.411 137.741H12.552c-1.236 0-2.163.733-2.163 1.54 0 .88 1.03 1.539 2.163 1.539h159.756c1.236 0 2.163-.733 2.163-1.539.103-.807-.927-1.54-2.06-1.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M142.853 20.275H36.042a10.838 10.838 0 0 0-10.87 10.87v73.216a10.838 10.838 0 0 0 10.87 10.869h106.811a10.838 10.838 0 0 0 10.869-10.869V31.144c0-5.928-4.841-10.869-10.869-10.869Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7F1F9",
    d: "M35.646 87.167c-2.371 0-4.347-1.976-4.347-4.348l.296-51.775c0-2.372 1.976-4.348 4.348-4.348H143.05c2.371 0 4.347 1.976 4.347 4.348l-.296 51.874c0 2.371-1.976 4.348-4.348 4.348H35.646v-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCF3FA",
    d: "M25.173 94.618v9.846c0 6.006 4.838 10.83 10.86 10.83h106.735c6.022 0 10.861-4.824 10.861-10.83v-9.846H25.173Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDE6EF",
    d: "M107.167 115.309H69.334v14.518h37.833v-14.518Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4D3DD",
    d: "M107.167 115.309H69.334v4.399h37.833v-4.399Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9F2FA",
    d: "M115.21 129.821H61.187c-5.273 0-9.452 4.222-9.452 9.329v1.669h73.027v-1.669c0-5.205-4.279-9.329-9.552-9.329Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M92.651 105.628c0 2.677-2.063 4.839-4.619 4.839-2.555 0-4.619-2.162-4.619-4.839 0-2.677 2.064-4.839 4.62-4.839 2.555 0 4.618 2.265 4.618 4.839Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#order_project_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.174 34.365H46.57c-1.473 0-2.75 1.143-2.75 2.667v3.905c0 1.429 1.179 2.667 2.75 2.667h81.604c1.473 0 2.75-1.143 2.75-2.667v-3.905c0-1.524-1.277-2.666-2.75-2.666Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M61.107 40.936a1.482 1.482 0 1 0 0-2.964 1.482 1.482 0 0 0 0 2.964ZM71.679 40.936a1.482 1.482 0 1 0 0-2.964 1.482 1.482 0 0 0 0 2.964ZM82.155 40.936a1.482 1.482 0 1 0 0-2.964 1.482 1.482 0 0 0 0 2.964ZM92.732 40.936a1.482 1.482 0 1 0 0-2.964 1.482 1.482 0 0 0 0 2.964ZM103.196 40.936a1.483 1.483 0 1 0 0-2.965 1.483 1.483 0 0 0 0 2.965ZM113.768 40.936a1.482 1.482 0 1 0 0-2.963 1.482 1.482 0 0 0 0 2.963Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.657,
    cy: 59.043,
    r: 9.786,
    fill: "#3B7CC9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m116.891 59.418 2.214 1.882 5.313-4.516"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.59 53.257a4 4 0 0 1 4-4h53.163a4 4 0 0 1 4 4v33.92H43.591v-33.92Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.706,
    height: 3.67,
    x: 52.154,
    y: 67.606,
    fill: "#D7F1F9",
    rx: 1.835
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 29.358,
    height: 3.67,
    x: 52.154,
    y: 76.168,
    fill: "#D7F1F9",
    rx: 1.835
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 29.358,
    height: 3.67,
    x: 52.154,
    y: 59.043,
    fill: "#D7F1F9",
    rx: 1.835
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#order_project_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#order_project_svg__c)",
    d: "M24.206 106.205c12.265 0 22.207-9.942 22.207-22.206S36.47 61.793 24.206 61.793C11.942 61.792 2 71.734 2 83.998s9.942 22.206 22.206 22.206Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.195 74.987c-.622 0-1.126.504-1.126 1.126V89.63a4.506 4.506 0 0 0 4.505 4.506H29.84c1.718 0 2.901-.742 3.617-1.736.674-.936.888-2.026.888-2.77 0-.622-.504-1.126-1.126-1.126h-3.38v-12.39c0-.623-.504-1.127-1.126-1.127H15.195Zm6.759 13.517h5.632V77.24H16.322v12.39a2.253 2.253 0 0 0 2.253 2.253c.382 0 .982-.124 1.453-.464.414-.298.8-.804.8-1.789 0-.622.504-1.126 1.126-1.126Zm.595 3.379h7.29c.984 0 1.49-.385 1.789-.799a2.22 2.22 0 0 0 .194-.328h-8.859a4.294 4.294 0 0 1-.414 1.127Zm-3.974-11.264c0-.622.504-1.126 1.126-1.126h4.505a1.126 1.126 0 1 1 0 2.252h-4.505a1.126 1.126 0 0 1-1.127-1.126Zm1.126 2.253a1.126 1.126 0 1 0 0 2.252h4.505a1.126 1.126 0 1 0 0-2.252h-4.505Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ACE6C5",
    d: "M139.102 1.931a1.93 1.93 0 1 1 3.862 0v9.655a1.931 1.931 0 0 1-3.862 0V1.93ZM170.162 32.132a1.93 1.93 0 1 1 0 3.862h-9.655a1.931 1.931 0 0 1 0-3.862h9.655ZM162.74 9.09a1.931 1.931 0 0 1 2.731 2.73l-6.827 6.828a1.931 1.931 0 0 1-2.731-2.73l6.827-6.828Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "order_project_svg__a",
    width: 95.103,
    height: 17.238,
    x: 41.82,
    y: 32.365,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "order_project_svg__b",
    width: 52.413,
    height: 52.413,
    x: 0,
    y: 59.792,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_29807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_91_29807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "order_project_svg__c",
    x1: 24.206,
    x2: 24.206,
    y1: 61.792,
    y2: 106.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })))));
};
export default SvgOrderProject;